export const toast = {
  namespaced: true,
  state: {
    type: null,
    snackbar: false,
    message: null,
    icon: null,
  },
  // actions: {
  //     success({ commit }, message) {
  //         commit('success', message);
  //     },
  //     error({ commit }, message) {
  //         commit('error', message);
  //     },
  //     info({ commit }, message) {
  //         commit('info', message);
  //     },
  //     clear({ commit }) {
  //         commit('clear');
  //     }
  // },
  mutations: {
    success(state, message) {
      state.type = 'success'
      state.snackbar = true
      state.message = message
      state.icon = 'check_circle'
    },
    error(state, message) {
      state.type = 'error'
      state.snackbar = true
      state.message = message
      state.icon = 'warning'
    },
    info(state, message) {
      state.type = 'info'
      state.snackbar = true
      state.message = message
      state.icon = 'info'
    },
    clear(state) {
      state.type = null
      state.snackbar = false
      state.message = null
      state.icon = null
    },
  },
}
